import { render, staticRenderFns } from "./table-normal.vue?vue&type=template&id=1ff57d74&scoped=true&"
import script from "./table-normal.vue?vue&type=script&lang=js&"
export * from "./table-normal.vue?vue&type=script&lang=js&"
import style0 from "./table-normal.vue?vue&type=style&index=0&id=1ff57d74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff57d74",
  null
  
)

export default component.exports